import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_WORKSPACE_BIDDERS_FOR_TABLE: TypedDocumentNode<Data, Variables> = gql`
  query getWorkspaceBiddersForTable(
    $first: Int
    $last: Int
    $sort: WorkspaceBidderSortInput
    $terms: [String!]
    $workspaceId: ID!
  ) {
    workspaceBidders(
      first: $first
      last: $last
      sort: $sort
      terms: $terms
      workspaceId: $workspaceId
    ) {
      nodes {
        accountType
        bidCpmAdjustment
        bidder {
          name
          code
        }
        bidderCode
        consentMode
        enabled
        id
        priority
        supplyChain {
          name
        }
        status
      }

      totalCount
    }
  }
`
